import { snakeCase } from "lodash";
import React from "react";
import { OverlayTrigger } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import { RenderWhen } from "../../../../../../components";
import { MitreAttackTechniqueWithSource } from "./MitreAttack";

import styles from "./mitre.module.scss";

interface IconProps {
  name: string;
  disabled: boolean;
  techniques: MitreAttackTechniqueWithSource[];
}
const MitreIcon: React.FC<IconProps> = ({
  name,
  disabled,
  techniques = []
}) => (
  <OverlayTrigger
    placement="bottom"
    overlay={
      <Tooltip
        key={name}
        style={{ display: disabled ? "none" : "" }}
        className="tooltip--wide"
        data-testid={`report_summary_mitre_item_tooltip_for_${snakeCase(name)}`}
      >
        {techniques?.map(({ id, name: techniqueName, source }) => (
          <div
            style={{ textAlign: "left" }}
            key={techniqueName}
            data-testid={`report_summary_mitre_technique_item_${id}`}
          >
            <span
              style={{
                fontWeight: "bold"
              }}
            >
              {id}
            </span>
            <span>
              {` - ${techniqueName}`}
              <span style={{ fontStyle: "italic" }}> ({source})</span>
            </span>
          </div>
        ))}
      </Tooltip>
    }
  >
    <div
      style={{ textAlign: "center", margin: "auto" }}
      data-testid={`report_summary_mitre_item_${snakeCase(name)}`}
    >
      <img
        key={name}
        alt={""}
        style={{ width: "32px", height: "24px", opacity: disabled ? 0.2 : 1 }}
        src={`${window.tcbase.urls.static}images/mitre_images/${name}.svg`}
      />

      <div className={styles.technique_label}>
        <span>{name}</span>{" "}
        <RenderWhen condition={Boolean(techniques.length)}>
          <span> ({techniques.length})</span>
        </RenderWhen>
      </div>
    </div>
  </OverlayTrigger>
);

export default MitreIcon;
